<template>
  <div class="box16">
    <div class="content swiper-content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in 7"
          :key="index"
        >
          <img
            :src="
              require(`../../../assets/coursePage/pythonData/box16/${
                index + 1
              }.jpg`)
            "
            alt
          />
        </swiper-slide>
      </swiper>
    </div>
    <div class="tip">
      * 为了避免对学员造成影响，以上数据做了部分隐藏处理
      <br />相关数据来源于公司内部真实统计
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      list: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
      swiperOption: {
        loop: true, // 循环模式选项
        autoplay: {
          delay: 30000000000000000, // 自动播放的时长
          stopOnLastSlide: false /* 触摸滑动后是否继续轮播 */,
          disableOnInteraction: false,
        },
        spaceBetween: 22,

        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          slideShadows: true, // 页面阴影效果
          rotate: 0, // 旋转的角度
          stretch: 50, // 拉伸   图片间左右的间距和密集度
          depth: 200, // 深度   切换图片间上下的间距和密集度
          modifier: 0.9, // 修正值 该值越大前面的效果越明显
        },
        pagination: {
          el: ".swiper-pagination-box16",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box16 {
  padding-top: 44px;
  padding-bottom: 88px;
  width: 100%;
  background: linear-gradient(180deg, #ffffff 0%, #e5f6ff 100%);
  .content {
    position: relative;
    padding-bottom: 22px;

    img {
      padding: 4px;
      width: 100%;
      height: 100%;
      background: #f5f9ff;
      border-radius: 20px;
      box-sizing: border-box;
    }
  }
  .tip {
    margin-top: 27px;
    text-align: center;
    font-family: PingFang SC;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 36px;
    letter-spacing: 0px;
    color: #24375c;
  }
  .swiper-content {
    position: relative;

    img {
      padding: 4px;
      width: 406px;
      height: 721px;

      border-radius: 20px;
      box-sizing: border-box;
      transition: all 0.3s;
    }
  }
  .swiper-slide {
    padding: 4px;
    width: 443px;
    height: 726px;

    border-radius: 20px;
    box-sizing: border-box;
  }

  .swiper-pagination-box16 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -17px;
    transform: translate(-50%, 0px);
    // width: 60px;
    // height: 6px;
    border-radius: 3px;
    // // background: #70c3f7;
    background-color: #b6ddff;
    // border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 10px;
    height: 6px;
    background-color: #b6ddff;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background-color: #57a3f5;
    border-radius: 3px;
  }
  .swiper-slide {
    display: flex;
    align-items: center;
    padding: 4px;
    width: 411px;
    height: 788px;

    border-radius: 20px;
    box-sizing: border-box;
  }
  .swiper-slide-active {
    img {
      width: 450px;
      height: 800px;
      border-radius: 24px;
      margin-left: -22px;
    }
  }
  .swiper-pagination-box12 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -20px;
    transform: translate(-50%, 0px);
  }
}
</style>
